import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
  PERFIL_ADMIN,
  getAdminEmpresa,
  getFinanceiroAgencia,
  getGestorEmpresa,
  getOperadorEmpresa,
  getPerfisVendedores, getFinanceiroCaixa,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';

export class MenuFechamentoCaixa extends Component {
  render () {
    return (
      <div className="area-home">
        <Titulo texto="Fechamento de Caixa" urlRetorno="/"/>
        <div className="row sistemas">
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-6 col-sm-6 col-md-3">
              <Link to="/painel-fechamento-caixa">
                <div className="card card-inicial ">
                  <div className="card card-inicial-interno ">
                    <i className="material-icons custom-icons"><AddCardOutlinedIcon className='css-icon' /></i>
                    <h5 className='nm-longo'>
                      Fechamento de Caixa (Usuário)
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
          <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id),
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id)]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-6 col-sm-6 col-md-3">
              <Link to="/painel-fechamento-caixa-agencia">
                <div className="card card-inicial ">
                    <div className="card card-inicial-interno ">
                      <i className="material-icons custom-icons"><AddBusinessOutlinedIcon className='css-icon' /></i>
                      <h5 className='nm-longo'>
                        Fechamento de Caixa (Agência)
                      </h5>
                    </div>
                </div>
              </Link>
            </div>
          </Autorizacao>
        </div>
      </div>
    );
  }
}
export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada ? state.empresaSelecionada : '',
    authentication: state.authentication
  }
}



export default withRouter(connect(mapStateToProps, {})(MenuFechamentoCaixa));
